import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { defineComponent as o, h as d } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const s = o({
  name: "TimePickerPanelCol",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    data: {
      type: Array,
      required: !0
    },
    activeValue: {
      type: [Number, String],
      default: null
    },
    // It should be required but vue's type seems to have bugs
    onItemClick: Function
  },
  render() {
    const {
      activeValue: n,
      onItemClick: t,
      clsPrefix: e
    } = this;
    return this.data.map((c) => {
      const {
        label: i,
        disabled: r,
        value: a
      } = c, l = n === a;
      return d("div", {
        key: i,
        "data-active": l ? "" : null,
        class: [`${e}-time-picker-col__item`, l && `${e}-time-picker-col__item--active`, r && `${e}-time-picker-col__item--disabled`],
        onClick: t && !r ? () => {
          t(a);
        } : void 0
      }, i);
    });
  }
});
export {
  s as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/time-picker/src/PanelCol.js
// module id = 1709
// module chunks = 41